/* ============
 * Default Layout
 * ============
 *
 * Used for the home and account pages
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */

import authService from "./../../services/auth";
import store from "./../../store";
import Vue from "vue";
import moment from "moment";
import mixin from "../../mixins/mixin";
import accountService from "./../../services/account";
import rentalService from "../../services/rental";
import bookingService from "../../services/booking";
import configurationService from "../../services/configuration";
import subscription from "../../services/subscription";

export default {
  /**
   * The Vuex store
   */
  store,

  data() {
    return {
      topHeight: 0,
      user: {
        id: store.state.account.id,
        web_key: store.state.web_key,
        full_name: store.state.account.full_name,
        email: store.state.account.email,
        parent_id: store.state.account.parent_id,
        avatar: store.state.account.avatar,
        first_name: store.state.account.first_name,
        last_name: store.state.account.last_name,
        lang: localStorage.getItem("lang")
          ? localStorage.getItem("lang")
          : "fr",
        country_id: 1,
        role: store.state.account.role,
        confirmed: store.state.account.confirmed,
        is_team_member: localStorage.getItem("is_team_member"),
        rights: store.state.account.rights,
        onBoarding: false,
        onboarding_step: store.state.account.onboarding_step,
        prelaunched_at: store.state.account.prelaunched_at,
        prelaunched_onboarding_at:
          store.state.account.prelaunched_onboarding_at,
        is_subscription_active: store.state.account.is_subscription_active,
        trial_period: store.state.account.trial_period,
        last_sync_time: store.state.account.last_sync_time,
        address: "test",
        city: "test",
        zip_code: "test",
        country: "test",
      },
      detectScreenSize: window.matchMedia("(max-width: 1000px)"),
      showModalButton: false,
      promise1: {},
      bookings: [],
      filterByName: "",
      activeStep: 1,
      error: null,
      success: false,
      loading: false,
      displayBanner: false,
      rentals: [],
      selectedSupermanager: false,
      selectedSupermanagerFull: false,
      countries: [],
      isLoading: false,
      isGettingBookings: false,
      airbnbAccount: {
        loading: false,
        error: null,
        verified: false,
        airbnbUsername: "",
        airbnbPassword: "",
        randomDeviceId: null,
        airbnbToken: "",
        airbnbUserId: null,
        airLockId: null,
      },
      verificationFrictionData: [],
      verificationFrictionType: "phone_verification_via_text",
      frictionDataAll: [],
      airbnbVerificationData: {},
      airbnbVerificationCode: "",
      verificationFrictionMethodData: {},
      airbnbAccounts: {},
      airbnbRentals: {},
      airbnbAttachedRentalIds: [],
      allRentalsSelected: false,
      smallLoading: false,
      supportAccess: false,
      billingInfo: {
        cardNumber: "",
        cardExpiration: "",
        cardCvc: "",
        loading: false,
      },
      stripe: null,
      stripeToken: "",
      billing: {},
      connectNewCard: true,
      subscriptionSuccess: false,
      prelaunch: false,
      stripe_account_name: "",
      stripeClientId: process.env.STRIPE_CLIENT_ID,
      calendarPage: "month",
      airlockData: {
        airlock: "",
        friction: "",
      },
      registration: true,
      airbnbUserIsV2: false,
      phoneNumberId: "",
      airLockUID: null,
      frictionDataReceived: false,
      listView: [],
      videoSrc: "",
      topBarInfoStyle: {
        width: "100%",
        color: "#FFFFFF",
        backgroundColor: "#D7092E",
        paddingTop: "10px",
        paddingBottom: "10px",
      },

      topBarInfoStyleAirbnbReconnect: {
        width: "100%",
        color: "#FFFFFF",
        backgroundColor: "#fb7f4b",
        paddingTop: "10px",
        paddingBottom: "10px",
      },
      topBarInfoText: "",
      topBarInfoTextAirbnbxml: "",
      topBarInfoEnabled: false,
    };
  },

  props: ["activeMenu"],

  mixins: [mixin],

  async mounted() {
    const vm = this;

    vm.topHeight = document.querySelector(".site-navbar").offsetHeight;

    // Listen for navbar height changes
    const navbar = document.querySelector(".site-navbar");
    if (navbar) {
      vm.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          vm.topHeight = entry.target.offsetHeight;
        }
      });
      vm.resizeObserver.observe(navbar);
    }

    // let input = document.getElementById("user-address");
    // let autocomplete = new google.maps.places.Autocomplete(input);
    // google.maps.event.addListener(autocomplete, "place_changed", () => {
    //   let place = autocomplete.getPlace();

    //   const result = place.address_components.reduce((acc, component) => {
    //     if (component.types.includes("locality")) {
    //       acc.city = component.long_name;
    //     } else if (component.types.includes("administrative_area_level_1")) {
    //       acc.state = component.long_name;
    //     } else if (component.types.includes("country")) {
    //       acc.country = component.long_name;
    //     } else if (component.types.includes("postal_code")) {
    //       acc.zipCode = component.long_name;
    //     }
    //     return acc;
    //   });

    //   console.log(result);

    //   // this.user.address =
    //   //   place.address_components[0].long_name +
    //   //   " " +
    //   //   place.address_components[1].long_name;
    //   // this.user.city = place.address_components[2].long_name;
    //   // this.user.zip_code = place.address_components[6].long_name;
    //   // this.user.country = place.address_components[5].long_name;
    // });

    accountService.getAirbnbAccounts(this);
    if ($.fn.jquery !== "2.2.4") {
      $.noConflict();
    }

    if (this.user.id) {
      this.calendarPage = localStorage.getItem(
        `calendar_page_type_${this.user.id}`
      )
        ? localStorage.getItem(`calendar_page_type_${this.user.id}`)
        : "month";
    }

    $("#rental-detail, .site-menubar-body, .site-menu-item, .page-content").on(
      "click",
      (e) => {
        if ($(e.target).data("toggle") !== "popover") {
          $('[data-toggle="popover"]').popover("hide");
        }
      }
    );

    await vm.disabled_banner(vm);
    if (
      !vm.account.email ||
      !vm.account.confirmed ||
      !vm.account.onBoarding ||
      vm.account.isSyncInProgress
    ) {
      await vm.fetch_account();

      Vue.config.lang = vm.user.lang;
      $("title").html(vm.$t("page_title"));
      if (!vm.user.confirmed) {
        $(".modal-not-confirmed").addClass("show");
        $("body").addClass("modal-open");
        $("body").append('<div class="modal-backdrop fade show"></div>');
        $(".modal-content").css({ display: "block" });
        $(".navbar").css({ "z-index": "0" });
      }

      if (
        vm.user.confirmed &&
        !vm.user.onBoarding &&
        vm.user.is_team_member === 0
      ) {
        $(".onBoarding-modal").addClass("show");
        $("body").addClass("modal-open");
        $("body").append('<div class="modal-backdrop fade show"></div>');
        $(".modal-content").css({ display: "block" });
        $(".navbar").css({ "z-index": "0" });
        if (this.user.onboarding_step == 8) {
          this.getAirbnbData();
        } else if (
          this.user.onboarding_step > 4 &&
          this.user.onboarding_step < 8
        ) {
          this.user.onboarding_step = 4;
          this.updateOnBoardingStep();
        }
      }

      if (vm.user.is_team_member === 1 && vm.user.rights) {
        const rightForSupport = vm.user.rights.filter(
          (right) => right.support === 1
        );
        if (rightForSupport.length > 0) {
          vm.supportAccess = true;
        } else {
          vm.supportAccess = false;
        }
      }

      vm.show_sync_in_process_modal();
      if (
        !this.user.is_subscription_active &&
        this.user.onBoarding === 1 &&
        this.user.isSyncInProgress === 0
      ) {
        this.openModal("#add-card-modal");
      }
    }

    vm.showPreLaunchModal();
    vm.fetch_configuration();
    document.title = vm.$t("page_title");

    // when screen size in small then 1000px show modal
    vm.showModal(vm.detectScreenSize);
    vm.detectScreenSize.addListener(vm.showModal);
  },

  methods: {
    showModal(ev) {
      if (ev.matches && this.user.showModal) {
        $("#modalBtn").click();
        Vue.$http
          .post("/user/showModal", { id: this.user.id })
          .then((response) => {})
          .catch((error) => {
            if (error.response) {
              context.loading = false;
              context.showToasterError(error);
            }
          });
      }
    },

    async disabled_banner() {
      await accountService.disabledBanner(this);
    },

    async fetch_account() {
      await accountService.fetchUserAccount(this);
      await store.dispatch("getAccount");
      FS.identify(this.user.web_key, {
        displayName: this.user.first_name,
        email: this.user.email,
      });
    },

    async fetch_configuration() {
      const vm = this;
      const response = await configurationService.get(vm);
      vm.videoSrc = response.conf.onboarding_video;
      vm.topBarInfoText = response.conf.top_bar_info_text;
      vm.topBarInfoEnabled =
        response.conf.top_bar_info_enabled && !this.user.top_bar_info_hidden;
      vm.topBarInfoStyle.backgroundColor = response.conf.top_bar_info_color;
    },

    hideTopBarInfo() {
      const vm = this;
      vm.topBarInfoEnabled = false;
      configurationService.hideTopBarInfo();
    },

    logout() {
      const vm = this;
      Vue.$http
        .post("/user/showModal", { id: this.user.id })
        .then(() => {})
        .catch((error) => {
          if (error.response) {
            vm.loading = false;
            vm.showToasterError(error);
          }
        });

      // close fresh chat
      window.fcWidget.close();
      window.fcWidget.destroy();

      authService.logout(this.$route.name);
    },

    globalSearch() {
      $("body").css("overflow", "hidden");
      $("#global-search").fadeIn();
      $("#overlay-search").focus();
    },

    closeGlobalSearch() {
      $("body").css("overflow", "auto");
      $("#global-search").fadeOut();
      this.filterByName = "";
    },

    getBooking() {
      this.isGettingBookings = true;
      Vue.$http
        .get("/bookings")
        .then((response) => {
          if (response && response.status === 200) {
            this.bookings = response.data.bookings;
            this.isGettingBookings = false;
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isGettingBookings = false;
        });
    },

    changeLang(lang) {
      const vm = this;
      Vue.config.lang = lang;
      vm.user.lang = lang;

      document.title = vm.$t("page_title");
      accountService.changeLang(this, { lang });
    },

    toBookingItem(id) {
      const vm = this;
      vm.closeGlobalSearch();
      Vue.router.push({
        name: "bookings.details.tab",
        params: { id, tab: "informations" },
      });
    },

    async next(step, airlockId = null, response = null, frictionData = null) {
      if (step == 1) {
        this.validate_data_in_first_step(this, this.user);
      } else if (step == 2) {
        this.edit(this.user, step);
      } else if (step == 3) {
        await this.submitBillingCheckout();
        this.billingInfo.loading = false;
      } else if (step == 0) {
        // sms verification
        this.user.onboarding_step = 0;
        this.updateOnBoardingStep();
      } else if (step == 4) {
        this.addAccount(this.airbnbAccount);
      } else if (step == 5) {
        this.user.onboarding_step = 5;
        this.airbnbAccount.airLockId = airlockId;
      } else if (step == 6) {
        this.user.onboarding_step = 6;
        this.airbnbAccount.airLockId = airlockId;
        if (response) {
          this.frictionDataAll = frictionData;
          this.airbnbVerificationData = {
            userId: response.client_error_info.airlock.user_id,
            id: response.client_error_info.airlock.id,
          };
          for (const key in frictionData) {
            if (frictionData.hasOwnProperty(key) && key < 2) {
              if (
                frictionData[key] &&
                frictionData[key].data &&
                frictionData[key].data.phone_numbers &&
                frictionData[key].data.phone_numbers[0]
              ) {
                const phoneNumber = frictionData[key].data.phone_numbers[0];
                const phoneNumberObject = {
                  text: `Confirm Your phone number ${
                    phoneNumber.obfuscated
                  } via ${key === 0 ? "text message" : "a phone call"}`,
                  name: frictionData[key].name,
                  id: `message${phoneNumber.id}`,
                  method: phoneNumber.verification_method,
                };
                this.verificationFrictionData.push(phoneNumberObject);
              }
            }
          }
          if (
            frictionData[2] &&
            frictionData[2].data &&
            frictionData[2].data.obfuscated_email_address
          ) {
            const emailObject = {
              text: `Confirm Your email ${frictionData[2].data.obfuscated_email_address}`,
              name: frictionData[2].name,
              id: `email${frictionData[2].data.delivery_methods[0].id}`,
              method: 2,
            };
            this.verificationFrictionData.push(emailObject);
          }
        }
      } else if (step == 7) {
        this.user.onboarding_step = 7;
      } else if (step == 8) {
        this.getAirbnbData();
      } else if (step == 9) {
        this.airbnbAccount.loading = true;
        this.addStripeAccount();
      } else if (step == 10) {
        store.dispatch("getAccount");
        this.user.onboarding_step = step;
        await this.updateOnBoardingStep();
        await this.show_sync_in_process_modal();
      } else if (step == 99) {
        // Airlock validation
        const waitForValidation = setInterval((_) => {
          accountService.verifyAirlockValidation(
            this,
            waitForValidation,
            this.airbnbAccount.airbnbUsername,
            true
          );
        }, 10000);
      }
    },

    previous(step) {
      this.user.onboarding_step = step - 1;
      this.updateOnBoardingStep();
    },

    openFreshChat() {
      window.fcWidget.init({
        token: "0640673e-c360-43ec-b547-9ced622e3610",
        host: "https://superhote.freshchat.com",
        externalId: this.user.email, // user’s id unique to your system
        firstName: this.user.first_name, // user’s first name
        lastName: this.user.last_name, // user’s last name
        email: this.user.email, // user’s email address
        // phone: this.user.phone, // phone number without country code
        // phoneCountryCode: "+1", // phone’s country code
      });
      window.fcWidget.open();

      this.closeModal("#support-modal");
    },

    get_started() {
      localStorage.removeItem("onboarding");
      this.fetch_account();
      $(".onBoarding-modal").removeClass("show");
      $("body").removeClass("modal-open");
      $("div.modal-backdrop.fade.show").remove();
      $(".navbar").css({ "z-index": "1701" });

      Vue.router.push({
        name: "onboarding.user",
      });
    },

    async edit(user, activeStep) {
      await accountService.editUserData(this, user, activeStep);
      await accountService.updateOnboardingStep(
        this,
        this.user.onboarding_step
      );
    },

    show_sync_in_process_modal() {
      if (this.user.isSyncInProgress) {
        if (!$(".sync-in-process-modal").hasClass("show")) {
          $(".sync-in-process-modal").addClass("show");
          $("body").addClass("modal-open");
          if (!$(".modal-backdrop")[0]) {
            $("body").append('<div class="modal-backdrop fade show"></div>');
            $(".modal-content").css({ display: "block" });
            $(".navbar").css({ "z-index": "0" });
          }
        }
      }
    },

    sync_all_data() {
      const vm = this;
      Vue.$http
        .get("/rentals/sync-data")
        .then((response) => {
          if (response.status === 200) {
            vm.loading = false;
            toastr.success(vm.$t("account.settings.successfully_updated"));
            vm.show_sync_in_process_modal();
          }
        })
        .catch((error) => {
          if (error.response) {
            vm.loading = false;
            vm.success = null;
            vm.showToasterError(error);
          }
        });
    },

    sync_rentals_data(activeStep) {
      const vm = this;
      Vue.$http
        .get("/rentals/sync-rentals-data")
        .then((response) => {
          if (response.status === 200) {
            this.get_all_rentals(activeStep);
            vm.loading = false;
            toastr.success(vm.$t("account.settings.successfully_updated"));
            vm.activeStep = activeStep + 1;
          }
        })
        .catch((error) => {
          if (error.response) {
            vm.loading = false;
            vm.success = null;
            vm.showToasterError(error);
            vm.activeStep = activeStep;
          }
        });
    },

    get_all_rentals(activeStep) {
      const vm = this;
      Vue.$http.get("/rentals").then((response) => {
        if (response.status === 200) {
          vm.rentals = response.data.rentals;
          for (let i = 0; i < this.rentals.length; i++) {
            vm.rentals[i].bookings = 0;
            vm.rentals[i].rates = 0;
            vm.rentals[i].blocked_dates = 0;
            vm.sync_bookings_data(vm.rentals[i], i);
            vm.sync_rates_data(vm.rentals[i], i);
            vm.sync_blocks_data(vm.rentals[i], i);
          }
          vm.loading = false;
          toastr.success(vm.$t("account.settings.successfully_updated"));
          vm.activeStep = activeStep + 1;
        }
      });
    },

    sync_bookings_data(rental, index) {
      const vm = this;
      Vue.$http
        .post("/rentals/sync-bookings-data", rental)
        .then((response) => {
          if (response.status === 200) {
            vm.rentals[index].bookings = 1;
            vm.loading = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            vm.loading = false;
            vm.showToasterError(error);
          }
        });
    },

    sync_rates_data(rental, index) {
      const vm = this;
      Vue.$http
        .post("/rentals/sync-rates-data", rental)
        .then((response) => {
          if (response.status === 200) {
            vm.rentals[index].rates = 1;
            vm.loading = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            vm.loading = false;
            vm.showToasterError(error);
          }
        });
    },

    sync_blocks_data(rental, index) {
      const vm = this;
      Vue.$http
        .post("/rentals/sync-blocks-data", rental)
        .then((response) => {
          if (response.status === 200) {
            vm.rentals[index].blocked_dates = 1;
            vm.loading = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            vm.loading = false;
            vm.showToasterError(error);
          }
        });
    },

    resend_email() {
      const vm = this;
      Vue.$http
        .get("/resend-confirmation")
        .then((response) => {
          if (response.status === 200) {
            toastr.success(this.$t("home.verify_email"));
          }
        })
        .catch((error) => {
          if (error.response) {
            vm.loading = false;
            vm.showToasterError(error);
          }
        });
    },

    checkUserAccessToTab(access) {
      const vm = this;
      if (vm.user.rights) {
        const rights = vm.user.rights;
        return rights.some((el) => el[access] == 1);
      }
      return true;
    },

    async validate_data_in_first_step(context, user) {
      await accountService.validateFirstStepUserData(context, user);
      await this.updateOnBoardingStep();
    },

    async getFrictionVew() {
      this.smallLoading = true;
      this.airlockData.friction = this.verificationFrictionType.toUpperCase();
      await accountService.getFrictionView(this);
    },

    async addAccount(account) {
      account.loading = true;
      account.error = null;
      account.success = null;
      await accountService.createNewAirbnbAccount(this, account, this.user);
      await this.updateOnBoardingStep(4);
      if (!account.verified) {
        account.loading = false;
      } else {
        if (account.success) {
          account.success = this.$t("onboarding.success");
        }
        if (account.error) {
          account.error = this.$t("onboarding.error");
        }
        account.loading = false;
        if (account.success) {
          this.activeStep = this.activeStep++;
        }
      }
    },

    verifyAccount(airLockId) {
      window.open(
        `https://www.airbnb.com/airlock?al_id=${airLockId}`,
        "_blank"
      );
      this.user.onboarding_step = 4;
    },

    async verifyAirbnbAccountViaPhoneOrEmail() {
      switch (this.verificationFrictionType) {
        case "phone_verification_via_text":
          this.verificationFrictionMethodData = this.frictionDataAll[0];
          break;
        case "phone_verification_via_call":
          this.verificationFrictionMethodData = this.frictionDataAll[1];
          break;
        case "email_code_verification":
          this.verificationFrictionMethodData = this.frictionDataAll[2];
          break;
      }
      if (this.verificationFrictionMethodData) {
        this.airbnbVerificationData.airlockId = this.airbnbAccount.airLockId;
        await accountService.verifyAirbnbAccountViaPhoneOrEmail(
          this,
          this.verificationFrictionMethodData,
          this.airbnbVerificationData,
          this.airbnbAccount.randomDeviceId,
          true
        );
      }
    },

    async checkAirBnbVerificationCode(pwdChanged = false) {
      this.smallLoading = true;
      if (this.airbnbUserIsV2) {
        const {
          airLockUID,
          phoneNumberId,
          airbnbVerificationCode: code,
        } = this;
        this.airbnbVerificationData = {
          airlockId: airLockUID,
          code,
          phoneNumberId,
          airbnbUserIsV2: true,
        };
        await accountService.checkAirbnbVerificationCode(
          this,
          { name: "verify_via_text" },
          this.airbnbVerificationData,
          this.airbnbAccount.randomDeviceId,
          this.airbnbVerificationCode,
          true,
          pwdChanged
        );
      } else if (
        this.verificationFrictionMethodData &&
        this.airbnbVerificationData
      ) {
        await accountService.checkAirbnbVerificationCode(
          this,
          this.verificationFrictionMethodData,
          this.airbnbVerificationData,
          this.airbnbAccount.randomDeviceId,
          this.airbnbVerificationCode,
          true,
          pwdChanged
        );
      }
    },

    async importAirbnbListings() {
      this.airbnbAccount.loading = true;
      await rentalService.importAirbnbListingsToBeds24(
        this,
        this.airbnbRentals
      );
    },

    selectAllRentals(id = null) {
      if (id == "all") {
        this.airbnbRentals.map(
          (rental) => (rental.checked = this.allRentalsSelected)
        );
      } else {
        const length = this.airbnbRentals.length;
        const selectedRentals = this.airbnbRentals.filter(
          (rental) => rental.checked === true
        );
        if (selectedRentals.length == length) {
          this.allRentalsSelected = true;
        } else {
          this.allRentalsSelected = false;
        }
      }
    },

    getBookingClassName(id, code, done) {
      if (done === 1 && id === 1) {
        return "confirmed";
      }
      if ((id === 1 && code === 12) || id === 3) {
        return "confirmed";
      } else if (id === 0 && code === 20) {
        return "refunded";
      } else if (id == 0) {
        return "cancelled";
      }
      return "";
    },

    cardExpChange() {
      let val = this.billingInfo.cardExpiration;
      if (
        (val.length == 1 && parseInt(val) > 1) ||
        (val.length == 2 && val.charAt(1) == "/") ||
        (val.length == 2 && val.charAt(1) == " ")
      ) {
        val = `0${parseInt(val)} / `;
      } else if (val.length == 2 && parseInt(val) == 1) {
        val = "01" + " / ";
      } else if (val.length == 2 && parseInt(val) == 0) {
        val = "0";
      } else if (val.length == 2 && parseInt(val) <= 12) {
        val += " / ";
      } else if (val.length == 2 && parseInt(val) > 12) {
        val = val.substring(val.length - 2, val.length - 1);
      } else if (val.length == 4) {
        val = val.substring(0, 1);
      } else if (val.length > 4) {
        const before = val.substring(0, 5);
        let after = val.substring(5, val.length);
        after = after.replace(/[\/ ]/g, "");
        val = before + after;
      }
      this.billingInfo.cardExpiration = val;
    },

    async submitBillingCheckout() {
      this.billingInfo.loading = true;
      await accountService.getStripeKey(this);

      let $form;

      if (this.prelaunch) {
        $form = $("#billingForm");
      } else {
        $form = $("#billingInfoForm");
      }

      const expiration = $form.find("#card-expiration-billing").val();
      const exp = expiration.split("/");

      $form.find("#exp_month").data("data-stripe", "exp_month");
      $form.find("#exp_month").val(exp[0].replace(" ", ""));
      $form.find("#exp_year").data("data-stripe", "exp_year");
      $form.find("#exp_year").val(exp[1].replace(" ", ""));

      await Stripe.card.createToken($form, this.stripeResponseHandler);
    },

    async stripeResponseHandler(status, response) {
      if (response.error) {
        let text = "";
        if (response.error.message.match(/A network error has occurred/)) {
          text = this.$t("payments.permalink.errors.network_error");
        } else if (
          response.error.message.match(/Your card number is incorrect/)
        ) {
          text = this.$t("payments.permalink.errors.card_number_incorrect");
        } else if (response.error.message.match(/Expired API Key/)) {
          text = this.$t("payments.permalink.errors.expired_api_key");
        } else if (
          response.error.message.match(/Your card's expiration year is invalid/)
        ) {
          text = this.$t("payments.permalink.errors.exp_year");
        } else {
          text = this.$t("payments.permalink.errors.contact_support");
        }

        // showing error message
        toastr.error(text);
        this.billingInfo.loading = false;
      } else {
        this.stripeToken = response.id;
        if (
          response.card &&
          response.card.id &&
          response.card.brand &&
          response.card.last4
        ) {
          this.user.stripe_token = response.id;
          this.user.card_brand = response.card.brand;
          this.user.card_last_four = response.card.last4;
          this.user.stripe_card_id = response.card.id;

          await accountService.editUserData(
            this,
            this.user,
            this.user.onboarding_step
          );

          this.createUserSubscriptions();

          if (this.prelaunch) {
            this.connectNewCard = false;
            this.prelaunch = false;
            await this.subscribePrelaunchUser();
          }
        }
      }
    },

    async showPreLaunchModal() {
      if (
        this.user.prelaunched_at !== null &&
        this.user.prelaunched_onboarding_at === null &&
        this.user.is_team_member === 0 &&
        !this.user.is_subscription_active
      ) {
        this.openModal(".prelaunch-modal");
      }
    },

    async connectStripeCard() {
      this.prelaunch = true;
      await this.submitBillingCheckout();
    },

    async subscribePrelaunchUser() {
      await accountService.subscribePrelaunchUser(this);
    },

    continueUseApp() {
      this.fetch_account();
      this.closeModal(".prelaunch-modal");
    },

    updateOnBoardingStep(step = null) {
      if (this.user.onboarding_step != 99) {
        accountService.updateOnboardingStep(
          this,
          step || this.user.onboarding_step
        );
      }
    },

    async getAirbnbData() {
      this.smallLoading = true;
      await accountService.getAirbnbAccounts(this);
      if (this.airbnbAccount.airbnbUserId == null) {
        const airbnbAccount = this.airbnbAccounts.find(
          (account) => account.user_id === this.user.id
        );
        if (airbnbAccount) {
          this.airbnbAccount.airbnbUserId = airbnbAccount.airbnb_user_id;
        }
      }

      await rentalService.getAccountListings(
        this,
        this.airbnbAccount.airbnbUserId
      );
    },

    createUserSubscriptions() {
      this.airbnbAccount.loading = true;
      subscription.createUserSubscriptions(this);
    },

    async addStripeAccount() {
      if (this.stripe_account_name !== "") {
        localStorage.setItem("stripe_account_type", "account");
        localStorage.setItem("settings_page", true);
        localStorage.setItem("stripe_name", this.stripe_account_name);
        await this.next(10);
        location.href = `https://connect.stripe.com/login?redirect=%2Foauth%2Fauthorize%3Fscope%3Dread_write%26response_type%3Dcode%26client_id%3D${this.stripeClientId}&force_login=true`;
      } else {
        toastr.error(this.$t("onboarding.stripe_account_connect_error"));
        this.airbnbAccount.loading = false;
      }
    },

    skipStripeAccountConnect() {
      this.next(10);
    },

    unLockUser() {
      accountService.unlockUser(this, this.account.email, true);
    },

    closeSyncModal() {
      $(".sync-in-process-modal").removeClass("show");
      $("body").removeClass("modal-open");
      $("div.modal-backdrop.fade.show").remove();
    },

    showUnSyncText() {
      const userSyncTimeAfterHour = moment(this.account.last_sync_time)
        .add(1, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      return (
        this.account.isSyncInProgress &&
        moment().format("YYYY-MM-DD HH:mm:ss") >= userSyncTimeAfterHour
      );
    },

    openAlvisPopup() {
      window.Alvis("identify", localStorage.getItem("user_id"));
      window.Alvis("show_checklist");
      this.closeModal("#support-modal");
    },

    showShouldSyncAirbnb(accounts) {
      if (window.location.href.indexOf("/account/settings") === -1) {
        const inactiveAccounts = accounts.filter(
          (account) => account.status === 0
        );
        if (inactiveAccounts.length > 0) {
          // toastr.error("Some of your Airbnb accounts are inactive. Please check your Airbnb accounts.");
          const exist = document.querySelector(".page-content");
          const alert = document.createElement("alert");
          alert.innerHTML = `<div class="alert alert-dismissible fade show" role="alert" style="background:#f5e1e5;margin-top:25px;"><i class="fa fa-exclamation-circle" style="margin-right:15px;font-size:14px;"></i>
           ${this.$t("account.users.airbnb_unauth")} ${this.$t(
            "account.users.airbnb_unauth_sync"
          )} : <a target=_blank href="https://superhote.com/reconnexion">https://superhote.com/reconnexion</a><button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button></div>`;
          exist.prepend(alert);
        }
      }
    },
  },

  components: {
    EducationalModal: require("components/educational-modal/educational-modal.vue"),
    VLoading: require("components/loading/loading.vue"),
    VBillingModal: require("../default/billing-modal"),
  },

  beforeDestroy() {
    $(".panel-overlay").off();

    // Clean up ResizeObserver
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },

  computed: {
    account() {
      return this.$store.state.account;
    },

    subscriptionStartDate() {
      if (this.user.lang) {
        let month = 1;

        if (this.user.trial_period && this.user.trial_period !== null) {
          month = this.user.trial_period;
        }
        return moment()
          .add(month, "month")
          .locale(this.user.lang)
          .format("DD MMM YYYY");
      }
    },
  },

  watch: {
    $route(to, from) {
      if (this.$store.state.account.airbnb_should_sync == 1) {
        this.showShouldSyncAirbnb(this.airbnbAccounts);
      }
    },
    airbnbAccounts(accounts) {
      this.showShouldSyncAirbnb(accounts);
    },

    frictionDataReceived(newData, oldData) {
      if (!oldData && newData) {
        const { airLockUID: airlockId, phoneNumberId } = this;
        const randomDeviceId = this.airbnbAccount.randomDeviceId;
        const data = { airlockId, phoneNumberId, randomDeviceId };
        accountService.sendSmsV2(this, data);
      }
    },

    async filterByName(newText) {
      if (newText) {
        this.isLoading = true;
        await bookingService.getBookingsForSorting(
          this,
          50,
          0,
          newText,
          "all",
          "",
          JSON.stringify({ checking: "desc" })
        );
        this.listView = this.bookings;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/layouts/default/default.js